/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessRelationType } from './BusinessRelationType';
import {
    BusinessRelationTypeFromJSON,
    BusinessRelationTypeFromJSONTyped,
    BusinessRelationTypeToJSON,
    BusinessRelationTypeToJSONTyped,
} from './BusinessRelationType';
import type { BusinessRelationStatus } from './BusinessRelationStatus';
import {
    BusinessRelationStatusFromJSON,
    BusinessRelationStatusFromJSONTyped,
    BusinessRelationStatusToJSON,
    BusinessRelationStatusToJSONTyped,
} from './BusinessRelationStatus';
import type { BusinessRelationLifecycle } from './BusinessRelationLifecycle';
import {
    BusinessRelationLifecycleFromJSON,
    BusinessRelationLifecycleFromJSONTyped,
    BusinessRelationLifecycleToJSON,
    BusinessRelationLifecycleToJSONTyped,
} from './BusinessRelationLifecycle';

/**
 * 
 * @export
 * @interface BusinessRelationTypeResponse
 */
export interface BusinessRelationTypeResponse {
    /**
     * 
     * @type {BusinessRelationType}
     * @memberof BusinessRelationTypeResponse
     */
    brType: BusinessRelationType;
    /**
     * 
     * @type {BusinessRelationStatus}
     * @memberof BusinessRelationTypeResponse
     */
    status?: BusinessRelationStatus;
    /**
     * 
     * @type {BusinessRelationLifecycle}
     * @memberof BusinessRelationTypeResponse
     */
    lifecycle?: BusinessRelationLifecycle;
}



/**
 * Check if a given object implements the BusinessRelationTypeResponse interface.
 */
export function instanceOfBusinessRelationTypeResponse(value: object): value is BusinessRelationTypeResponse {
    if (!('brType' in value) || value['brType'] === undefined) return false;
    return true;
}

export function BusinessRelationTypeResponseFromJSON(json: any): BusinessRelationTypeResponse {
    return BusinessRelationTypeResponseFromJSONTyped(json, false);
}

export function BusinessRelationTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessRelationTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'brType': BusinessRelationTypeFromJSON(json['brType']),
        'status': json['status'] == null ? undefined : BusinessRelationStatusFromJSON(json['status']),
        'lifecycle': json['lifecycle'] == null ? undefined : BusinessRelationLifecycleFromJSON(json['lifecycle']),
    };
}

export function BusinessRelationTypeResponseToJSON(json: any): BusinessRelationTypeResponse {
    return BusinessRelationTypeResponseToJSONTyped(json, false);
}

export function BusinessRelationTypeResponseToJSONTyped(value?: BusinessRelationTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brType': BusinessRelationTypeToJSON(value['brType']),
        'status': BusinessRelationStatusToJSON(value['status']),
        'lifecycle': BusinessRelationLifecycleToJSON(value['lifecycle']),
    };
}

